var map = {
	"./": 1384,
	"./Clutch": 2680,
	"./Clutch.js": 2680,
	"./NewUi": 2681,
	"./NewUi.js": 2681,
	"./OldUi": 2682,
	"./OldUi.js": 2682,
	"./index": 1384,
	"./index.js": 1384,
	"./style": 855,
	"./style.js": 855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4227;